import VehicleList from "../VehicleList/VehicleList"

export const VehicleBar = ({
  formData,
  setSelectedAlarmIds,
  selectedAlarmIds,
  updateVehicleResult,
  onSubmit
}) => {
  return (
    <div>
      <VehicleList
        formData={formData}
        onSubmit={onSubmit}
        selectedAlarmIds={selectedAlarmIds}
        setSelectedAlarmIds={setSelectedAlarmIds}
        updateVehicleResult={updateVehicleResult}
      />
    </div>
  )
}
